module.exports = __webpack_public_path__ + "img/GK9901-GK.cd9006a0.jpg";